import getApiBaseUrl from '../utils/apiBaseUrl';
import readJsonResponse from '../utils/readJsonResponse';

async function readJson(response) {
  const message = response.status === 404
    ? 'Blog post not found'
    : 'Failed to load blog content';
  return readJsonResponse(response, { errorMessage: message });
}

function blogListUrl({ limit, offset } = {}) {
  const params = new URLSearchParams();
  if (Number.isInteger(limit) && limit > 0) {
    params.set('limit', String(limit));
  }
  if (Number.isInteger(offset) && offset > 0) {
    params.set('offset', String(offset));
  }
  const query = params.toString();
  return `${getApiBaseUrl()}/blog${query ? `?${query}` : ''}`;
}

export async function fetchBlogPosts(options) {
  const data = await readJson(await fetch(blogListUrl(options)));
  return Array.isArray(data.posts) ? data.posts : [];
}

export async function fetchBlogPost(slug) {
  const data = await readJson(await fetch(`${getApiBaseUrl()}/blog/${encodeURIComponent(slug)}`));
  return data.post || null;
}
